<template>
<div>
<v-layout align-content-center text-xs-center wrap>
   <v-flex xs6 mr-3>
   <v-text-field data-trustor="firstname"
      v-model="trustor.firstName" 
      label="Firstname" 
      required>
   </v-text-field>
   </v-flex>
   <v-flex xs4>
   <v-text-field data-trustor="middlename"
      v-model="trustor.middleName" 
      label="Middle Name" >
   </v-text-field>
   </v-flex>
   </v-layout>
   <v-text-field data-trustor="lastname"
      v-model="trustor.lastName" 
      label="Lastname" 
      required>
   </v-text-field>
   <v-text-field data-trustor="address"
      v-model="trustor.address" 
      label="Street Address" 
      required>
   </v-text-field>
   <v-text-field data-trustor="city"
      v-model="trustor.city" 
      label="City" 
      required>
   </v-text-field>
   <v-text-field data-trustor="postalcode"
      v-model="trustor.postalCode" 
      label="Postalcode" 
      required>
   </v-text-field>
   <v-text-field data-trustor="country"
      v-model="trustor.country" 
      label="Country" 
      required>
   </v-text-field>
   <v-layout align-content-center text-xs-center wrap>
   <v-flex md2 mr-3>
   <v-text-field data-trustor="areacode"
      v-model="trustor.areacode" 
      label="Areacode" 
      disabled>
   </v-text-field>
   </v-flex>
   <v-flex md6 >
   <v-text-field data-trustor="phone"
      v-model="trustor.phone" 
      label="Phone" 
      required>
   </v-text-field>
   </v-flex>
   </v-layout>
   <v-text-field data-trustor="email"
      v-model="trustor.email" 
      label="Email" 
      required>
   </v-text-field>
   <v-text-field data-trustor="title"
      v-model="trustor.title" 
      label="Title" 
      required>
   </v-text-field>
</div>
</template>

<script>
export default {
  data: () => ({}),
  props: ["trustor"],
  computed: {},
  methods: {}
};
</script>

<style>
</style>
